import axios from 'axios';
import { API } from '@/config/api';

/**
 * Submit a property search enquiry with contact details.
 * Saves a lead in the admin panel via POST /api/search-inquiry.
 * Does not filter listings — this is lead capture only.
 */
export async function submitSearchInquiry({
  searchType,
  sourcePage,
  filters = {},
  searchMode,
  contact = {},
}) {
  const toNumber = (value) => {
    if (value === undefined || value === null || value === '') return undefined;
    const n = Number(value);
    return Number.isFinite(n) ? n : undefined;
  };

  const payload = {
    search_type: searchType,
    source_page: sourcePage,
    location: filters.location || undefined,
    max_price: toNumber(filters.maxPrice ?? filters.max_price),
    min_price: toNumber(filters.minPrice ?? filters.min_price),
    min_surface: toNumber(filters.minSurface ?? filters.min_surface),
    min_bedrooms: toNumber(filters.bedrooms ?? filters.minBedrooms ?? filters.min_bedrooms),
    property_type: filters.propertyType || filters.property_type || undefined,
    pieces: filters.pieces || undefined,
    search_mode: searchMode || undefined,
    first_name: contact.first_name?.trim(),
    last_name: contact.last_name?.trim(),
    email: contact.email?.trim(),
    phone: contact.phone?.trim(),
    message: contact.message?.trim() || undefined,
  };

  const response = await axios.post(`${API}/search-inquiry`, payload, {
    withCredentials: true,
  });
  return response.data;
}
